export enum PageCategory {
  MainPage = 'Strona korporacyjna',
  BiomasserPage = 'Biomasser',
  TomasserPage = 'Tomasser',
}
